import React from "react";

function SocialLinks(props) {
  return (
    <div className={props.classname}>
      <a
        style={{ cursor: "pointer" }}
        onClick={() =>
          window.open("https://www.linkedin.com/in/irfangg/", "_blank")
        }
      >
        <i className="fa fa-facebook" />
      </a>
      <a
        style={{ cursor: "pointer" }}
        onClick={() => window.open("https://twitter.com/irfangg6", "_blank")}
      >
        <i className="fa fa-twitter scaleOnHover" />
      </a>
      <a
        style={{ cursor: "pointer" }}
        onClick={() =>
          window.open("https://www.linkedin.com/in/irfangg/", "_blank")
        }
      >
        <i className="fa fa-linkedin scaleOnHover" />
      </a>
    </div>
  );
}

export default SocialLinks;
